import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import CryptoJS from 'crypto-js';

/*
  Generated class for the EncryptionProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class EncryptionProvider {

  constructor(public http: HttpClient) {
    console.log('Hello EncryptionProvider Provider');
  }


/* 
 let key = CryptoJS.enc.Utf8.parse("10c4jceefa9mtaoyeuqzg85h6");
console.log(key);
let result = CryptoJS.TripleDES.encrypt(pt, key,{mode:CryptoJS.mode.ECB});
console.log(CryptoJS.enc.Hex.stringify(result.ciphertext)); */

makeEncryption(pin, key){
    let encKey =  CryptoJS.enc.Utf8.parse(key);
    let result = CryptoJS.TripleDES.encrypt(pin, encKey,{mode:CryptoJS.mode.ECB});
    return CryptoJS.enc.Hex.stringify(result.ciphertext);
}

makeSha(password){
  return  CryptoJS.enc.Hex.stringify( CryptoJS.SHA256(password));
}

}



// WEBPACK FOOTER //
// ./src/providers/encryption/encryption.ts